module.exports = __webpack_public_path__ + "img/soulition1.7659252d.png";